<app-overlay-panel #overlay [showCloseIcon]="false" [dismissable]="false">
  <div class="time-picker">
    <select [(ngModel)]="selectedHour" (change)="timeChange()">
      <option *ngFor="let h of hours" value="{{h}}">{{h}}</option>
    </select>
    <select [(ngModel)]="selectedMin" (change)="timeChange()">
      <option *ngFor="let m of minutes" value="{{m}}">{{m}}</option>
    </select>
    <select [(ngModel)]="timePeriod" (change)="timeChange()">
      <option value="AM">AM</option>
      <option value="PM">PM</option>
    </select>
  </div>
</app-overlay-panel>